import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

// If BACKEND_URL is a raw IP address (not a proper domain), use relative URLs
// so that image paths like /api/uploads/... are served via the nginx proxy
// on the same origin, avoiding mixed-content blocks and internal-IP routing issues.
const isRawIp = /^https?:\/\/\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}(:\d+)?$/.test(BACKEND_URL);
const RESOLVED_BACKEND = isRawIp ? "" : BACKEND_URL;

const api = axios.create({
  baseURL: `${RESOLVED_BACKEND}/api`,
  withCredentials: true,
  timeout: 15000,
});

api.interceptors.request.use((config) => {
  const token = typeof window !== "undefined" ? localStorage.getItem("token") : null;
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const BACKEND = RESOLVED_BACKEND;

// Merge-save helper — used by every CMS editor that reads/writes a shared
// document (e.g. /cms/site, which holds header, footer, nav, and identity
// fields all in one record). Instead of overwriting the whole document with
// this session's possibly-stale local copy, it re-fetches the latest
// document, then applies only the fields that differ from `baseline` (the
// pristine snapshot this editor loaded at mount) — so one section's save can
// never reset a section it never touched. Returns the merged document that
// was actually persisted, so callers can sync it back into local state.
export async function mergeSaveCmsField(endpoint, current, baseline) {
  const fresh = (await api.get(endpoint)).data || {};
  const base = baseline || {};
  const changed = {};
  Object.keys(current || {}).forEach((k) => {
    if (current[k] !== base[k]) changed[k] = current[k];
  });
  const merged = { ...fresh, ...changed };
  await api.put(endpoint, merged);
  return merged;
}

export default api;
